var __jsx = React.createElement;
import { AccordionDetails, InputLabel } from '@material-ui/core';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { VariantAccordion, VariantAccordionSummary } from 'components/common/material-ui/custom-components';
import { CoverDefaultImageInput } from '../../../CoverDefaultImageInput';
import { CoverVariantImageInput } from '../../../CoverVariantImageInput';
import { AccordionContainer, Icon, MaxSizeInfo, MinusIcon, PlusIcon } from './CoverImagesField.style';

var CoverImagesField = function CoverImagesField(_ref) {
  var _formField$configurat;

  var formField = _ref.formField;
  var configurations = compact(Object.values((_formField$configurat = formField.configuration) !== null && _formField$configurat !== void 0 ? _formField$configurat : {}));

  var _useState = useState({
    defaultImageUrl: undefined,
    reset: false
  }),
      defaultImageConfig = _useState[0],
      setDefaultImageConfig = _useState[1];

  return __jsx(React.Fragment, null, __jsx(CoverDefaultImageInput, {
    name: "".concat(formField.name, ".default"),
    labelId: formField.labelId,
    defaultValue: formField.defaultValue,
    ratio: formField.ratio,
    constraints: formField.constraints,
    setImageConfig: setDefaultImageConfig,
    defaultImageConfig: defaultImageConfig
  }), __jsx(AccordionContainer, {
    "data-testid": "coverImagesAccordion",
    visible: !isEmpty(defaultImageConfig.defaultImageUrl)
  }, configurations.map(function (imageField) {
    return __jsx(VariantAccordion, {
      square: true,
      key: imageField.labelId
    }, __jsx(VariantAccordionSummary, {
      expandIcon: __jsx(Icon, null, __jsx(MinusIcon, {
        className: "openedAccordion",
        "data-testid": "minusIcon"
      }), __jsx(PlusIcon, {
        className: "closedAccordion",
        "data-testid": "plusIcon"
      })),
      "aria-controls": "cover-images-content",
      id: "cover-images-header"
    }, __jsx(InputLabel, null, __jsx(FormattedMessage, {
      id: imageField.labelId
    })), __jsx("div", null, __jsx(MaxSizeInfo, null, __jsx(FormattedMessage, {
      id: "imageInput.maxLabel",
      values: {
        maxWidth: imageField.constraints.maxWidth,
        ratioWidth: imageField.ratio.width,
        ratioHeight: imageField.ratio.height
      }
    })))), __jsx(AccordionDetails, null, __jsx(CoverVariantImageInput, {
      name: "".concat(formField.name, ".").concat(imageField.name),
      labelId: imageField.labelId,
      defaultValue: imageField.defaultValue,
      ratio: imageField.ratio,
      defaultImageConfig: defaultImageConfig,
      constraints: formField.constraints
    })));
  })));
};

export default CoverImagesField;